import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

export const Image = styled.img`
  width: 80px;
  height: 80px;
`

export const Content = styled.div`
  width: 100%;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  label {
    font-size: 14px;
    margin: 10px 0 5px;
  }

  input {
    box-shadow: 0px 4px 16px rgb(0 0 0 / 50%);
    border: 1px solid #dedede;
    border-radius: 5px;
    height: 35px;
    padding: 0 10px;
    width: 250px;
  }

  small {
    font-size: 10px;
    margin-top: 5px;
    text-align: center;
  }
`
